import { LearningChallengesCompetencies,
    LearningChallengesDomain, LearningChallengesGrades,
    LearningChallengesSubject, LearningChallengesTopic,
    } from '@/models/groups/learning-challenges';
import { ReportContext } from '@/models/groups/report';
import { sortByProperty } from '@/utils/utils';

export class LearningChallengesSerilaizer {

    private static INSTANCE = new LearningChallengesSerilaizer();

    public static get instance() {
        return this.INSTANCE;
    }

    public normalizeLearningChallenges(payload: any) {
        const contextPayload: any = payload.context ? payload.context : {};
        const dataPayload: any = payload.data ? payload.data : [];

        const data: LearningChallengesGrades[] = [];
        const context: ReportContext = {
            report: contextPayload.report || null,
            hierarchy: contextPayload.hierarchy || null,
            tenants: contextPayload.tenants || [],
            groupId: contextPayload.group_id || null,
            groupType: contextPayload.group_type || null,
            week: contextPayload.week || null,
            month: contextPayload.month || null,
            year: contextPayload.year || null,
            duration: contextPayload.duration || null,
            subject: contextPayload.subject || null,
            framework: contextPayload.framework || null,
        };
        dataPayload.forEach((item: any) => {
            const subjects = this.normalizeSubjects(item);
            const competencyCount = subjects.reduce(
                (a: any, b: any) => a + b.competencyCount, 0);
            const struggleItem: LearningChallengesGrades = {
                gradeId: item.grade_id,
                grade: item.grade,
                gradeSeq: item.grade_seq,
                description: item.description,
                subjects,
                competencyCount,
            };
            data.push(struggleItem);
        });
        sortByProperty(data, 'gradeSeq', 'ASC');
        return {
            context,
            data,
        };
    }

    private normalizeSubjects(payload: any) {
        const subjects = payload.subjects || [];
        return subjects.map((subject: any) => {
            const domains = this.normalizeDomains(subject);
            const competencyCount = domains.reduce(
                (a: any, b: any) => a + b.competencyCount, 0);
            return {
                subject: subject.subject,
                subjectCode: subject.subject_code,
                studentCount: subject.student_count,
                framework: subject.framework,
                domains,
                competencyCount,
            } as LearningChallengesSubject;
        });
    }

    private normalizeDomains(payload: any) {
        const domains = payload.domains || [];
        return domains.map((domain: any) => {
            const topics = this.normalizeTopics(domain);
            const competencyCount = topics.reduce(
                (a: any, b: any) => a + b.competencies.length, 0);
            return {
                domainName: domain.domain_name,
                domainCode: domain.domain_code,
                domainSeq: domain.domain_seq,
                studentCount: domain.student_count,
                topics,
                competencyCount,
            } as LearningChallengesDomain;
        });
    }

    private normalizeTopics(payload: any) {
        const topics = payload.topics || [];
        return topics.map((topic: any) => {
            return {
                topicName: topic.topic_name,
                topicCode: topic.topic_code,
                topicSeq: topic.topic_seq,
                studentCount: topic.student_count,
                competencies: this.normalizeCompetencies(topic),
            } as LearningChallengesTopic;
        });
    }

    private normalizeCompetencies(payload: any) {
        const competencies = payload.competencies || [];
        return competencies.map((competency: any) => {
            return {
                compCode: competency.comp_code,
                compName: competency.comp_name,
                studentCount: competency.student_count,
                displayCode: competency.comp_display_code,
                compStudentDesc: competency.comp_student_desc,
                compSeq: competency.comp_seq,
            } as LearningChallengesCompetencies;
        });
    }

}


export const learningChallengesSerilaizer = LearningChallengesSerilaizer.instance;
